const boxShadow = {
  shadowOne: "0px 1px 2px rgba(0, 0, 0, 0.12)",
  shadowTwo: "0px 4px 8px rgba(0, 0, 0, 0.1)",
  shadowThree: "0px 2px 8px rgba(0, 0, 0, 0.3)",
  innerShadow: "inset 1px 2px 2px rgba(0, 0, 0, 0.12)",
};

export default boxShadow;
